import { blue, blueGrey, deepOrange, yellow } from "@mui/material/colors";
import { blend } from "@mui/system";
import { DateTime } from "luxon";

export const AllowedGraphTypes = [
  "hazardousWaste",
  "hazardousWasteByMonth",
  "highestGeneratingWasteStreams",
] as const;

export type AllowedGraphType = (typeof AllowedGraphTypes)[number];

export function formatMonth(date: string, isFirstMonth: boolean) {
  const month = DateTime.fromFormat(date, "yyyy-MM-dd");
  if (month.month === 1 || isFirstMonth) {
    return month.toFormat("LLL\nyyyy");
  }
  return month.toFormat("LLL");
}

export const colorMap = {
  "Vendor Hazardous": deepOrange[300],
  "e‑Manifest Hazardous": blueGrey[100],
  "Vendor Acute": deepOrange[800],
  "e‑Manifest Acute": blueGrey[300],
  "Vendor State Regulated": yellow[700],
  "e‑Manifest State Regulated": blue[200],
};

/** Opaque, pre-mixed with the surface, so the hover band and grid don't show through. */
export function episodicTint(sourceColor: string, surface: string) {
  return blend(surface, sourceColor, 0.3);
}
